interface AuthorAvatarProps {
  name: string;
  avatar?: string;
}

export default function AuthorAvatar({ name, avatar }: AuthorAvatarProps) {
  if (avatar?.length) {
    return (
      <img
        className="rounded-full bg-neutral-300 w-7 h-7 mr-2 object-cover"
        src={avatar}
        alt={name}
      />
    );
  }
  return (
    <div className="rounded-full bg-neutral-200 w-7 h-7 mr-2 flex items-center justify-center font-bold">
      <span className="text-neutral-400">{name.charAt(0)}</span>
    </div>
  );
}
